import Cookies from "js-cookie";

export const VWS_URL = process.env.VUE_APP_VWS_URL
const regexDomain = new RegExp('([a-z\-0-9]{2,63})\.([a-z\.]{2,5})$');
const urlParts = regexDomain.exec(window.location.hostname);

export const SUB_DOMAIN = urlParts[0];
export const VS_URL = process.env.VUE_APP_VS_URL
export const ENABLE_MENU_DASHBOARD = process.env.VUE_APP_SHOW_MENU_DASHBOARD
export const APP_ENV = process.env.VUE_APP_APP_ENV
export const VEUS_COMPANY_ID = process.env.VUE_APP_VEUS_COMPANY_ID
export const VEUS_PERFIL = process.env.VUE_APP_VWS_PERFIL
export const TOKEN_DEVELOP = process.env.VUE_APP_VWS_TOKEN_DEVELOP

export const ACTUAL_LANGUAGE = Cookies.get('user_language') ? Cookies.get('user_language') : process.env.VUE_APP_LANGUAGE
